import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import { motion, AnimatePresence } from 'framer-motion';
import noop from 'lodash/fp/noop';
const DEFAULT_ANIMATION_TIME_IN_MS = 270;
const Collapse = (props) => {
    const { open = false, unmountOnExit = false, appear = false, timeout = DEFAULT_ANIMATION_TIME_IN_MS, onEntered = noop, onExited = noop, onAnimationStart = noop, children, } = props;
    const shouldKeepContentInDom = !unmountOnExit;
    const handleAnimationStart = () => onAnimationStart();
    const handleAnimationComplete = (definition) => {
        if (definition === 'open') {
            onEntered();
        }
        if (definition === 'collapsed') {
            onExited();
        }
    };
    const variants = {
        open: { opacity: 1, height: 'auto' },
        collapsed: { opacity: 0, height: 0 },
    };
    return (_jsx(_Fragment, { children: _jsx(AnimatePresence, Object.assign({ initial: appear, exitBeforeEnter: true }, { children: (open || shouldKeepContentInDom) && (_jsx(motion.div, Object.assign({ initial: 'collapsed', animate: open ? 'open' : 'collapsed', exit: 'collapsed', className: 'collapse display-block width-100pct', variants: variants, transition: { duration: timeout / 1000, ease: [0.04, 0.62, 0.23, 0.98] }, onAnimationComplete: handleAnimationComplete, onAnimationStart: handleAnimationStart }, { children: children }), 'content')) })) }));
};
export default Collapse;
